import { Trigger } from '@ekkogmbh/apisdk';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { TriggerCard } from '../../OperationGroups/Components/TriggerCard';

interface ItemOperationTriggerDialogProps extends Omit<DialogProps, 'classes' | 'title'> {
  onClose: () => void;
  open: boolean;
  triggers: Trigger[];
}

export class CompartmentOperationTriggerDialog extends React.Component<ItemOperationTriggerDialogProps> {
  public state = {
    open: true,
  };

  public render(): React.JSX.Element {
    const { triggers, onClose, ...rest } = this.props;

    return (
      <Dialog onClose={onClose} fullWidth={true} maxWidth={'lg'} {...rest}>
        <DialogTitle id="alert-dialog-title">Triggers</DialogTitle>
        <DialogContent>
          <div
            style={{
              width: '100%',
              padding: 16,
              marginBottom: 16,
            }}
          >
            <Grid container spacing={2} alignItems={'stretch'}>
              {triggers.map((trigger: Trigger, index: number) => (
                <Grid item lg={3} md={6} xs={12} key={index}>
                  <TriggerCard trigger={trigger} />
                </Grid>
              ))}
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant={'contained'} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
